import React from 'react';
import cn from 'classnames';

import PoweredBy from 'containers/PoweredBy.container';

const Layout = ({
  children,
  isFull,
  isGray,
  isSmallScreen,
  layoutClassName,
  layoutContentClassName,
  poweredByClassName,
  showPoweredBy,
}) => {
  const content = isFull ? (
    <div
      className={cn('d-flex flex-column', {
        [layoutClassName]: layoutClassName,
        'bg-white content-inner': !isGray,
      })}
      style={{ minHeight: !isSmallScreen ? '100%' : '' }}
    >
      {children}
      {showPoweredBy && (
        <PoweredBy className={poweredByClassName} white={false} />
      )}
    </div>
  ) : (
    children
  );

  return (
    <div
      className={cn('layout', {
        'stretch fixed d-flex flex-column is-full': isFull,
      })}
    >
      <div
        className={cn('content', {
          [layoutContentClassName]: layoutContentClassName,
          'p-3': isFull && !isSmallScreen,
          'p-25': isFull && isSmallScreen,
          'pb-57 pb-sm-3': isFull,
          'bg-faded-3': isFull || isGray,
          'is-gray': isGray,
        })}
      >
        {content}
      </div>
    </div>
  );
};

export default Layout;
